export enum EntryPoints {
  ACTIVITY_FEED = 'activity_feed',
  ZERO_SCRIBE_MODAL = 'zero_scribe_modal',
  EMPTY_ACTIVITY = 'empty_activity',
  EMPTY_DASHBOARD = 'empty_dashboard',
  EMPTY_DOCUMENTS = 'empty_documents',
  DASHBOARD_PLACEHOLDER = 'dashboard_placeholder',
  DASHBOARD_HEADER_CAPTURE = 'dashboard_header_capture',
  DASHBOARD_HEADER_BROWSER = 'dashboard_header_browser',
  DASHBOARD_AI_GENERATED_SUGGESTION = 'dashboard_ai_generated_suggestion',
  EXTENSION = 'extension',
  EXTENSION_RECORD_TRIGGER = 'extension_record_trigger',
  STICKY_ACTIVATION_CHECKLIST = 'sticky_activation_checklist',
  SIDEBAR = 'sidebar',
  START_RECORDING_PAGE = 'start_recording_page',
  INSIGHTS_PAGE = 'insights_page',
  WORKSPACE_ROUTE_PARAMS = 'workspace_route_params',
  VIEWER_PAGE_FOOTER = 'viewer_page_footer',
  VIEWER_PAGE_CAPTURE = 'viewer_page_capture',
  VIEWER_INTRO_PAGE = 'viewer_intro_page'
}
